"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _TooltipContent = _interopRequireDefault(require("../Tooltip/TooltipContent"));

var _ContextMenuModule = _interopRequireDefault(require("./ContextMenu.module.scss"));

var _excluded = ["trigger", "forwardedRefPropName", "passOpenStateAs", "children", "onClose", "onOpen", "open", "defaultOpen", "classes"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ContextMenu = function ContextMenu(_ref) {
  var trigger = _ref.trigger,
      forwardedRefPropName = _ref.forwardedRefPropName,
      passOpenStateAs = _ref.passOpenStateAs,
      children = _ref.children,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      open = _ref.open,
      defaultOpen = _ref.defaultOpen,
      classes = _ref.classes,
      props = _objectWithoutProperties(_ref, _excluded);

  var triggerRef = (0, _react.useRef)(null);
  var ref = typeof trigger.type !== 'string' ? forwardedRefPropName : 'ref';
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    onClose: onClose,
    onOpen: onOpen,
    withAnimation: true,
    trigger: /*#__PURE__*/_react["default"].cloneElement(trigger, _defineProperty({}, ref, triggerRef)),
    passOpenStateAs: passOpenStateAs,
    open: open,
    defaultOpen: defaultOpen,
    as: _TooltipContent["default"],
    modalProps: _extends({
      triggerRef: triggerRef
    }, props),
    classes: _extends({}, classes, {
      wrapper: (0, _classnames["default"])(_ContextMenuModule["default"].wrapper, classes.wrapper),
      modal: (0, _classnames["default"])(_ContextMenuModule["default"].menu, classes.menu),
      bg: (0, _classnames["default"])(_ContextMenuModule["default"].bg, classes.bg)
    })
  }, children);
};

ContextMenu.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  defaultOpen: false,
  align: 'center',
  position: 'top',
  forwardedRefPropName: 'forwardedRef',
  offsetX: 10,
  offsetY: 10,
  viewportOffset: 5,
  classes: {
    tooltip: '',
    bg: ''
  }
};
var _default = ContextMenu;
exports["default"] = _default;